/**
 * VergleichAmpel — the Ch-7.2 Ampel dot for one matrix cell / offer (P2 Placement Slice 11, Tab 4b).
 */

import { VERGLEICH_AMPEL_LABELS, type VergleichAmpel as Ampel } from '@brokly/shared';
import { StatusDot, type StatusTone } from '../../components/ui/StatusDot';

const TONE: Record<Ampel, StatusTone> = {
  gruen: 'success',
  gelb: 'warning',
  rot: 'danger',
  grau: 'neutral',
  neutral: 'neutral',
};

export function VergleichAmpel({ ampel, label, size = 'md' }: { ampel: Ampel; label?: string; size?: 'sm' | 'md' }) {
  const title = VERGLEICH_AMPEL_LABELS[ampel];
  return (
    <span data-testid="vergleich-ampel" data-ampel={ampel} title={title} className={size === 'sm' ? 'text-xs' : undefined}>
      <StatusDot tone={TONE[ampel]} label={label ?? title} />
    </span>
  );
}
